export default "__VITE_ASSET__W0xC5zLi__"